import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './ClientSection.css';

/* ---------- LOGO IMPORTS ---------- */
import img1 from '../../assets/Clients/cit.png';
import img2 from '../../assets/Clients/velnexus.png';
import img3 from '../../assets/Clients/velammalvidyalaya.png';
import imgMgr from '../../assets/Clients/MgrUnivsty.png';
import img4 from '../../assets/Clients/snm.png';
import img5 from '../../assets/Clients/FestonSolor.png';
import img6 from '../../assets/Clients/Feston.png';
import img7 from '../../assets/Clients/Deye.png';
import img8 from '../../assets/Clients/semicon.png';
import img9 from '../../assets/Clients/Fesren.png';
import img10 from '../../assets/Clients/plugzmart.png';
import img11 from '../../assets/Clients/caninecrown.png';
import img12 from '../../assets/Clients/ATSS.png';
import img13 from '../../assets/Clients/janta.png';
import img14 from '../../assets/Clients/NVK.png';
import img15 from '../../assets/Clients/KCee.png';
import img16 from '../../assets/Clients/JKB.png';
import img17 from '../../assets/Clients/Aulpha.png';
import img18 from '../../assets/Clients/Pramatt.png';
import img19 from '../../assets/Clients/windplus.png';
import img20 from '../../assets/Clients/vinyas.png';
import img21 from '../../assets/Clients/horizon.png';
import img22 from '../../assets/Clients/PrimeAuto.png';
import img23 from '../../assets/Clients/Traverse.png';
import img24 from '../../assets/Clients/NilamFresh.png';
import img25 from '../../assets/Clients/smile.png';
import img26 from '../../assets/Clients/zique.png';
import img27 from '../../assets/Clients/upperroom.png';
import img28 from '../../assets/Clients/flipperclip.png';
import img29 from '../../assets/Clients/bestforpets.png';
import img30 from '../../assets/Clients/walt.png';
import img31 from '../../assets/Clients/sife.png';
import img32 from '../../assets/Clients/cata.png';
import img33 from '../../assets/Clients/manasa.png';
import img34 from '../../assets/Clients/mycons.png';
import img35 from '../../assets/Clients/greenFuturz.png';
import img36 from '../../assets/Clients/amalam.png';
import img37 from '../../assets/Clients/Aiwo.png';
import img38 from '../../assets/Clients/Dazbog.png';
import img39 from '../../assets/Clients/DynamicStamping.png';
import img40 from '../../assets/Clients/Ganga.png';
import img41 from '../../assets/Clients/SriHousing.png';
import imgkidzee from '../../assets/Clients/Kidzee.png';  
import imglittle from '../../assets/Clients/LittleMillennium.png';
import imgprime from '../../assets/Clients/PrimeRehab.png';
import swathy from '../../assets/Clients/Swathy.webp';
import nura from '../../assets/Clients/Nura.webp';
import Tag from '../../assets/Clients/Tag.webp';

/* ---------- COMPONENT ---------- */
const ClientSection = () => {

  const allLogos = [
    img1, img2, img3, imgMgr, img4, img5, img6, img7, img8, img9, img10,
    img40,imgkidzee,imglittle, img11, img12, img13, img14, img15, img16, img17, img18, img19,
    img20, img21, img22, img23,swathy, img24,nura, img25, img26, img27, img28, img29,
    img30, img31, img32, img33, img34, imgprime,img35,Tag, img36, img37, img38, img39, img41,imgprime
  ];

  const row1 = allLogos.slice(0, 10);
  const row2 = allLogos.slice(10, 20);
  const row3 = allLogos.slice(20, 31);
  const row4 = allLogos.slice(31);

  const MarqueeLine = ({ logos, direction, extraClass = '' }) => (
    <div className="client-marquee-wrapper">
      <div className={`client-marquee-track ${direction} ${extraClass}`}>
        {[...logos, ...logos, ...logos].map((logo, index) => (
          <div key={index} className="client-logo-card">
            <img src={logo} alt="Client Logo" />
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <section className="client-section-root">
      <Container fluid>

        <Row className="justify-content-center mb-5">
          <Col lg={10} className="text-center">
            <h2 className="client-section-title">Our Clients</h2>
          </Col>
        </Row>

        {/* Row 1 → RIGHT */}
        <MarqueeLine logos={row1} direction="client-slide-right" />

        {/* Row 2 → LEFT */}
        <MarqueeLine logos={row2} direction="client-slide-left" extraClass="mt-4" />

        {/* Row 3 → RIGHT */}
        <MarqueeLine logos={row3} direction="client-slide-right" extraClass="mt-4" />

        {/* Row 4 → LEFT */}
        <MarqueeLine logos={row4} direction="client-slide-left" extraClass="mt-4" />

      </Container>
    </section>
  );
};

export default ClientSection;
